<template>
  <div
    v-if="fullscreen"
    class="loading-mask"
  >
    <md-progress md-indeterminate />
  </div>
  <div
    v-else
    class="loading_container"
  >
    <div id="loading">
      <div
        id="loading_1"
        class="loading"
      />
      <div
        id="loading_2"
        class="loading"
      />
      <div
        id="loading_3"
        class="loading"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    fullscreen: Boolean,
    default: false
  }
}
</script>

<style lang="scss">
  @import '../../../static/stylesheets/variables';

/* COMPONENT: commom/Loading.vue */
  .loading-mask {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.7);
    top: $mainHeaderHeight;
    z-index: 120;


    .md-progress {
      height: 10px;
      background-color: #ff9ea3;

      .md-progress-track {
        &::before,
        &::after {
          background-color: #b80711;
        }
      }
    }
  }

  .loading_container {
    #loading{
      position: relative;
      width: 59px;
      height: 28px;
      margin: 0 auto 0;
    }

    .loading{
      position: absolute;
      top: 0;
      width: 28px;
      height: 28px;
      animation-name: bounce_loading;
      animation-duration: 1.5s;
      animation-iteration-count: infinite;
      animation-direction: normal;
      border-radius: 28px;
      border: 1px solid #727272;
    }

    #loading_1{
      left: 0;
      animation-delay: 0.6s;
    }

    #loading_2{
      left: 15px;
      animation-delay: 0.75s;
    }

    #loading_3{
      left: 30px;
      animation-delay: 0.9s;
    }

    @keyframes bounce_loading{
      0% {
        opacity: 0;
      }

      30% {
        opacity: 1;
      }

      100% {
        opacity: 1;
        transform:scale(.21);
        border: 1px solid #727272;
      }
    }
  }
</style>
